import React from 'react';

// local dependencies
import { withHeaderAndFooter } from 'ui/hoc/withHeaderAndFooter';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { reports as Reports } from 'ui/views/layouts/reports';
 *
 * // render
 * <Reports propName='propValue'/>
 */
const reportsError = () => {
    return (
        <div className='ui-reports'>
            <WidgetError size='large'/>
        </div>
    );
};

// set display name
reportsError.displayName = 'reportsError';

// set default props
reportsError.defaultProps = {};

// prop types
reportsError.propTypes = {};

/************************************************************** */

const _reportsSuccess = ( props ) => {
    return (
        <div className='ui-reports'>
            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
            />
        </div>
    );
};

// set display name
_reportsSuccess.displayName = 'reportsSuccess';

// set default props
_reportsSuccess.defaultProps = {};

// prop types
_reportsSuccess.propTypes = {};

// view with header and footer
const reportsSuccess = withHeaderAndFooter( _reportsSuccess );

/************************************************************** */

const reportsPreloader = () => {
    return (
        <div className='ui-reports-preloader'>
            <HeartBeatPreloader className='ui-reports-preloader__animation' />
        </div>
    );
};

// set display name
reportsPreloader.displayName = 'reportsPreloader';

// set default props
reportsPreloader.defaultProps = {};

// prop types
reportsPreloader.propTypes = {};

/************************************************************** */

export const reports = withNetworkState( reportsPreloader, reportsSuccess, reportsError );
